<template>
    <div class="page-section">
        <a-card :bordered="false" style="width: 100%">
            <template v-if="title" slot="title">
                <a-breadcrumb separator=">">
                    <a-breadcrumb-item>
                        <router-link to="/cliente/monitores/cotacoes">
                            Home
                        </router-link>
                    </a-breadcrumb-item>
                    <a-breadcrumb-item class="order-page-title">
                        {{ title }}
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </template>
            <template v-else-if="heading" slot="title">
                <div class="v2-tab-hd">
                    <h2>{{ heading }}</h2>
                </div>
            </template>
            <template v-if="title || heading" slot="extra">
                <div class="title-actions">
                    <slot name="actions" />
                    <a-button type="danger" @click="$emit('limpar')">
                        <i class="fa-solid fa-filter-circle-xmark"></i> Limpar Filtros
                    </a-button>
                    <a-button v-if="hasDrawer" type="primary" @click="drawerVisible = true">
                        <i class="fa-solid fa-filter"></i> Mais Filtros
                    </a-button>
                </div>
            </template>

            <a-form layout="vertical" style="width: 100%" @submit.prevent="$emit('filtrar')">
                <a-row type="flex" :gutter="[12, 12]">
                    <a-col v-for="field in inlineFields" :key="field.key" :xs="24" :sm="12" :md="8" :lg="spanOf(field)">
                        <FilterField :field="field" :filters="filters" @enter="$emit('filtrar')" />
                    </a-col>
                    <a-col class="actions-col">
                        <a-form-item class="item-button">
                            <div class="actions-right">
                                <template v-if="!title && !heading">
                                    <a-button type="danger" @click="$emit('limpar')">
                                        <i class="fa-solid fa-filter-circle-xmark"></i> Limpar Filtros
                                    </a-button>
                                    <a-button v-if="hasDrawer" type="primary" @click="drawerVisible = true">
                                        <i class="fa-solid fa-filter"></i> Mais Filtros
                                    </a-button>
                                </template>
                                <a-button type="default" icon="search" @click="$emit('filtrar')">Filtrar</a-button>
                            </div>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>

            <AdvancedFiltersDrawer v-if="hasDrawer" :visible.sync="drawerVisible" @apply="apply" @clear="clear">
                <a-row v-for="(pair, index) in drawerRows" :key="index" :gutter="16">
                    <a-col v-for="field in pair" :key="field.key" :xs="24" :md="12">
                        <a-form-item :label="field.label">
                            <FilterField :field="field" :filters="filters" labelled @enter="apply" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </AdvancedFiltersDrawer>
        </a-card>
    </div>
</template>

<script>
import AdvancedFiltersDrawer from "@/components/cliente/monitors/AdvancedFiltersDrawer.vue";
import FilterField from "./filter-field.vue";

const SPANS = { period: 5, range: 4, text: 3 };

export default {
    name: "VisitFilters",
    components: { AdvancedFiltersDrawer, FilterField },
    props: {
        title: { type: String, default: "" },
        heading: { type: String, default: "" },
        filters: { type: Object, required: true },
        fields: { type: Array, required: true },
    },
    data() {
        return {
            drawerVisible: false,
        };
    },
    computed: {
        inlineFields() {
            return this.fields.filter((field) => !field.advanced);
        },
        drawerRows() {
            const rows = [];
            for (let index = 0; index < this.fields.length; index += 2) rows.push(this.fields.slice(index, index + 2));
            return rows;
        },
        hasDrawer() {
            return this.fields.some((field) => field.advanced);
        },
    },
    methods: {
        spanOf(field) {
            if (field.span) return field.span;
            if (field.type === "select") return field.multiple ? 3 : 4;
            return SPANS[field.type] || 3;
        },
        apply() {
            this.drawerVisible = false;
            this.$emit("filtrar");
        },
        clear() {
            this.drawerVisible = false;
            this.$emit("limpar");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_list-page-v2";

.actions-col {
    flex: 1 1 auto;
}
</style>
